<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">新增车牌</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
    <!-- 新增车牌banner 开始 -->
    <div class="page_top"></div>
    <!-- 新增车牌banner 结束 -->
    <!-- 新增车牌表单  开始 -->
    <div class="page_taocan licenseEdit_taocan">
      <div class="page_inputfrom licenseEdit_input1">
        <div class="licenseEdit_checktitle"><span class="bitian">*</span>车牌号码:</div>
        <input class="page_checkinput" placeholder="请输入车牌号码" v-model="car_no" />
      </div>
      <div class="page_inputfrom licenseEdit_input">
        <div class="licenseEdit_checktitle1">品牌:</div>
        <input class="page_checkinput" maxlength="20" placeholder="请输入品牌" v-model="brand" />
      </div>
      <div class="page_inputfrom licenseEdit_input">
        <div class="licenseEdit_checktitle1">车型:</div>
        <input class="page_checkinput" maxlength="20" placeholder="请输入车型" v-model="vehicle_type" />
      </div>
    </div>
    <!-- 新增车牌表单  结束 -->
    <!-- 提交 开始 -->
    <div class="page_button licenseEdit_button" @click="addCard()">
      <div class="page_zhifu">添加</div>
    </div>
    <!-- 提交 结束 -->
  </div>
</template>

<script>
  // import swal from 'sweetalert'
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        id: "", // 上一页获取车信息id,默认为空
        car_no: '', // 车牌号码,默认为空
        brand: '', // 品牌,默认为空
        vehicle_type: '', // 车型,默认为空
        showTopTips: [{
          text: '请填写正确的车牌!',
          checked: false
        }], // 错误提示列表
        buttonClicked: false // 防止支付重复点击,默认为false
      }
    },
    created() {
      // let data = getCurrentPages()[getCurrentPages().length - 2].data
      // let isEdit = !!this.$route.query.index
      // // wx.setNavigationBarTitle({
      // //   title: isEdit ? '修改车牌' : '新增车牌'
      // // })

      // this.isEdit=isEdit,
      // this.id = isEdit ? Number(this.$route.query.id) : '',
      // this.car_no = isEdit ? Number(this.$route.query.car_no) : '',
      // this.brand = isEdit ? Number(this.$route.query.brand) : '',
      // this.vehicle_type = isEdit ? Number(this.$route.query.vehicle_type) : ''

      // this.id = isEdit ? data.licenseList[Number(this.$route.query.index)].id : '',
      // this.car_no = isEdit ? data.licenseList[Number(this.$route.query.index)].car_no : '',
      // this.brand = isEdit ? data.licenseList[Number(this.$route.query.index)].brand : '',
      // this.vehicle_type = isEdit ? data.licenseList[Number(this.$route.query.index)].vehicle_type : ''

    },
    mounted() {

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      addCard() {
        // 防止重复点击
        this.buttonClickedFun(1000)
        let that = this
        let car_no = this.car_no.replace(!
          /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/,
          '')
        console.log('车牌号：', car_no)
        console.log('品牌：', that.brand)
        console.log('车型：', that.vehicle_type)
        if (that.isEdit) {
          let requestData = {
            id: '' + that.id,
            car_no: car_no,
            brand: '' + that.brand,
            vehicle_type: '' + that.vehicle_type
          }
          that.request('editCar', requestData)
        } else {
          let requestData = {
            id: '' + that.id,
            car_no: car_no,
            brand: '' + that.brand,
            vehicle_type: '' + that.vehicle_type
          }
          that.request('addCar', requestData)
        }
      },

      // 调用接口
      request(type = '', requestData = {}) {
        let data = {}
        let that = this
        switch (type) {
          // 新增车信息
          case 'addCar':
            httper.post('user/add-car', requestData, res => {
              if (res.code === 0) {
                // this.$swal({text: '新增成功'})
                this.$toast({
                  message: "新增成功!",
                })
                that.$router.go(-1);
                // that.$router.push({ path: '/taoyao' })

              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            //   console.log('新增车信息', res.data)
            //   wx.showToast({
            //     title: '新增成功',
            //     success () {
            //       setTimeout(() => { wx.navigateBack() }, 1500)
            //     }
            //   })
            // })
            break
            // 编辑车信息
          case 'editCar':
            httper.post('user/edit-car', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '编辑成功'
                })
                // that.$router.push({ path: '/taoyao' })
                that.$router.go(-1);
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            //   console.log('编辑车信息', res.data)
            //   wx.showToast({
            //     title: '编辑成功',
            //     success () {
            //       setTimeout(() => { wx.navigateBack() }, 1500)
            //     }
            //   })
            // })
            break
        }
      }
    },
  }
</script>

<style scoped>
  .licenseEdit_taocan {
    /* height: 210px;
    top: 88px; */
    height: 100%;
  }

  ::-webkit-input-placeholder {
    text-align: start;
    color: rgba(187, 187, 187, 1);
    font-size: 14px;
  }

  .licenseEdit_input1 {
    margin: 20px 20px 40px 20px;
  }

  .licenseEdit_input {
    margin: 40px 20px;
  }

  .licenseEdit_checktitle {
    margin-right: 20px;
  }

  .licenseEdit_checktitle1 {
    margin-right: 48px;
  }

  .licenseEdit_button {
    /* margin-top: 150px; */
  }
  .bitian{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/licenseEdit.vue